<div
  [ngClass]="siteName == 'HotelCollection' ? 'hc-deal' : 'deal'"
  [style.background-image]="'url(' + item?.imageUrl + ')'"
  (click)="onDealSelected()"
>
  <div [ngClass]="siteName == 'HotelCollection' ? 'hc-details' : 'details'">
    <p
      [ngClass]="
        appContext.siteName == 'ShamalGroup' ? 'sg-description' : 'description'
      "
    >
      {{ item?.desc }}
    </p>
    <p [ngClass]="appContext.siteName == 'ShamalGroup' ? 'sg-title' : 'title'">
      {{
        appContext.siteName !== "HostMyTrips" &&
        appContext.siteName !== "OneStopParking"
          ? item?.title
          : ""
      }}
    </p>
    <!-- <p class="price-info">
      <span>From {{item?.fromPrice}}</span>
    </p> -->
  </div>
</div>
